import React, { Component } from "react";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import { GenderService } from "../../../../../service/settings/manage/gender.service.js";
import { employmentTypeService } from "../../../../../service/settings/manage/employment_type.service.js";
import { educationService } from "../../../../../service/settings/manage/educational_qualification.service.js";
import { modeService } from "../../../../../service/settings/manage/mode_of_employment.service.js";
import { StatusTypesService } from "../../../../../service/settings/manage/status_type.service.js";
import { StatusService } from "../../../../../service/settings/manage/status.service.js";
import "../../../../../components/admin/css/common.css";
import { UserManagementService } from "../../../../../service/user_management/user_management.service";
import sweetAlert, {
  sweetStatusAlert,
} from "../../../../../components/common/SweetAlert";
import SimpleReactValidator from "simple-react-validator";
import RegBTeacherDocSubmission from "./RegBTeacherDocSubmission.js";
import { roleService } from "../../../../../service/user_management/role.service";
import { StaffService } from "../../../../../service/user_management/staff.service";
import config from "../../../../../helper/config";
import { customerConstants } from "../../../../../helper/constants.js";
import DatePicker from "react-datepicker";
import {
  cgcDocSubmisBlobName,
  regBTeacherUploadTypes,
} from "../../../../../helper/namespace.js";
import { AzureStorageManage } from "../../../../../helper/azureStorageManage.js";
import { TeacherService } from "../../../../../service/manage/registration/reg_b_teacher.service.js";
import "./courselist.css";

import {
  Checkbox,
  CircularProgress,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";

const getCustomerFeatureFlag = () => {
  return config.customerConfigs.featureFlag;
};

let addBtnStyle, closeBtnStyle;
const customer = getCustomerFeatureFlag();
switch (customer) {
  case customerConstants.EXO_CUSTOMER1:
    break;
  case customerConstants.EXO_CUSTOMER2:
    closeBtnStyle = {
      color: "var(--maincolor-cmc)",
      backgroundColor: "#E5F5FF",
      borderColor: "transparent",
    };
    addBtnStyle = {
      color: "#fff",
      backgroundColor: "var(--maincolor-cmc)",
      borderColor: "transparent",
    };
    break;
  default:
    break;
}

export default class RegBAddTeacherModel extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
      teachers: [],
      first_name: "",
      last_name: "",
      dob: "",
      email: "",
      phone_number: "",
      gender_id: "",
      status_id: "",
      created_on: "",
      created_by: "",
      genders: [],
      titles: [],
      adm_statuses: [],
      statusTypes: [],
      AdmStatustype: "Availability",
      showInsertModal: false,
      isLoading: false,
      isTableDataLoading: true,
      limit: 10, // Set the desired limit
      offset: 0, // Set the desired offset
      search_term: "",
      totalTeachers: 10,
      currentPage: 0,
      isModified: false,
      isAddressesLoading: false,
      editVisibility: false,
      addVisibility: false,
      deleteVisibility: false,
      sortColumn: "user_code", // Default sort column
      sortDirection: "desc",
      errorProvince: [],
      errorCity: [],
      addressValidity: [],
      hidden: false,
      node_mid: null,
      user_list_table_id: null,
      session_adm_id: null,
      nic: "",
      type_id: "",
      address_1: "",
      user_id: "",
      is_lg_user: "",
      user_name: "",
      breadcrumb2: null,
      nodeTitle: null,
      main_table_id: null,
      showPrivModel: false,
      roles: [],
      role_code: null,
      assignedRoles: [],
      isPrivModalLoading: false,
      privedTeacher: null,
      empTypes: [],
      education: [],
      edu_id: "",
      modes: [],
      mode_id: "",
      uploadFiles: {
        selectedFilePhoto: [],
        selectedFileCv: [],
        selectedFileNIC: [],
        selectedFileOther: [],
      },
      higher_professional_qualifications: "",
      industry_experience: "",
      teaching_experience: "",
      enrollments: this.props?.enrollments || [],
      checked_enrollments: [],

      lg_user_id: sessionStorage.getItem("manage_user_id"),
      lg_user_table_id: sessionStorage.getItem("table_log_id"),
    };

    this.createValidationsInstance();
    this.formInitialState = {
      first_name: "",
      last_name: "",
      dob: "",
      email: "",
      phone_number: "",
      gender_id: "",
      status_id: "",
      created_on: "",
      created_by: "",
    };
  }

  createValidationsInstance() {
    this.validator = new SimpleReactValidator({
      validators: {
        address: {
          message: "The :attribute must be a valid address",
          rule: (val, params, validator) => {
            return (
              validator.helpers.testRegex(val, /^[a-zA-Z-/:0-9,\s]+$/i) &&
              params.indexOf(val) === -1
            );
          },
          messageReplace: (message, params) =>
            message.replace(":values", this.helpers.toSentence(params)), // optional
        },
        dateBefore: {
          message: "The :attribute must be before current date",
          rule: (val, params, validator) => {
            const selectedDate = new Date(val);
            const currentDate = new Date();
            return selectedDate < currentDate;
          },
          messageReplace: (message, params) =>
            message.replace(":values", this.helpers.toSentence(params)), // optional
          required: true,
        },
        phone_number: {
          message: "The :attribute must be a valid phone number",
          rule: (val, params, validator) => {
            const isTenDigitsStartingWithZero =
              val.length === 10 && val.startsWith("0");
            const isNineDigits = val.length === 9 && !val.startsWith("0");
            return isTenDigitsStartingWithZero || isNineDigits;
          },
          messageReplace: (message, params) =>
            message.replace(":values", this.helpers.toSentence(params)), // optional
          required: true,
        },
      },
    });
    this.updateValidator = new SimpleReactValidator();
  }

  componentDidMount() {
    this.loadInitialData();
  }

  handleSearch = (event) => {
    const search_term = event.target.value.trim();
    const regex = /^[a-zA-Z0-9][a-zA-Z0-9@\s.&]*$/;

    if (search_term === "" || regex.test(search_term)) {
      this.setState(
        {
          search_term,
          isTableDataLoading: true,
          offset: 0,
          currentPage: 0,
          searchError: false,
        },
        () => {
          // Call the debounced version of fetchStudentData
          this.debouncedHandleSearch();
        }
      );
    } else {
      this.setState({ search_term, searchError: true });
    }
  };

  loadInitialData() {
    this.setState(
      {
        user_list_table_id: sessionStorage.getItem("table_log_id"),
        session_adm_id: sessionStorage.getItem("manage_user_id"),
      },
      () => {
        this.getAllGenders();
        this.getAllStatusTypes();
        this.getAllRoles();
        this.getAllEmpTypes();
        this.getAllEducations();
        this.getAllModes();
      }
    );
  }

  getAllRoles() {
    roleService.getAll().then((res) => {
      this.setState({ roles: res.data });
    });
  }

  getAllModes() {
    modeService.getAllModes().then((res) => {
      this.setState({ modes: res.data });
    });
  }

  getAllEmpTypes() {
    employmentTypeService.getAllEmpTypes().then((res) => {
      this.setState({ empTypes: res.data });
    });
  }

  getAllEducations() {
    educationService.getAllEducation().then((res) => {
      this.setState({ education: res.data });
    });
  }

  getAllGenders() {
    GenderService.getAllGenders().then((res) => {
      this.setState({ genders: res.data });
    });
  }

  getAllStatusTypes() {
    StatusTypesService.getAll().then((res) => {
      this.setState({ statusTypes: res.data });
      this.getAllStatuses();
    });
  }

  getAllStatuses() {
    const adm_type_id = this.getRespectiveStatusTypeID(
      this.state.AdmStatustype
    );
    StatusService.getByTypeId(adm_type_id).then((res) => {
      this.setState({ adm_statuses: res.data });
    });
  }

  handlePageChange = (event, newPage) => {
    const { limit } = this.state;
    const newOffset = newPage * limit;
    this.setState(
      {
        offset: newOffset,
        isTableDataLoading: true,
        currentPage: newPage,
      },
      () => {
        this.fetchAllTeachers();
      }
    );
  };

  handleRowsPerPageChange = (event) => {
    const newLimit = parseInt(event.target.value, 10);
    const newPage = Math.floor(this.state.offset / newLimit);
    this.setState(
      {
        limit: newLimit,
        offset: newLimit * newPage,
        isTableDataLoading: true,
        currentPage: newPage,
      },
      () => {
        this.fetchAllTeachers();
      }
    );
  };

  handleSortChange = (sortColumn) => {
    // If the same column is clicked, toggle the sort direction
    const { sortColumn: currentSortColumn, sortDirection } = this.state;
    const newSortDirection =
      currentSortColumn === sortColumn && sortDirection === "asc"
        ? "desc"
        : "asc";

    this.setState(
      {
        sortColumn,
        sortDirection: newSortDirection,
        offset: 0, // Reset offset when changing sorting
        currentPage: 0,
        isTableDataLoading: true,
      },
      () => {
        this.fetchAllTeachers();
      }
    );
  };

  handleSweetAlert = (toggleFunction, modalVisibility) => {
    if (this.state.isModified) {
      sweetAlert().then((response) => {
        this.validator.purgeFields();
        this.validator.hideMessages();
        this.setState(this.formInitialState);
        this.setState(() => ({
          [modalVisibility]: response,
          isModified: false,
        }));
        this.toggleAddTeacherModal();
        toggleFunction();
      });
    } else {
      this.validator.purgeFields();
      this.validator.hideMessages();
      this.setState(this.formInitialState);
      this.toggleAddTeacherModal();
      toggleFunction();
    }
  };

  handleChange = (event) => {
    const { name, value } = event.target;
    this.setState(() => ({ [name]: value, isModified: true }));
  };

  handleDatePickerChange = (value) => {
    const dateObject = value ? new Date(value) : undefined;
    const year = dateObject.getFullYear();
    const month = ("0" + (dateObject.getMonth() + 1)).slice(-2); // Adding 1 because getMonth() returns zero-based index
    const day = ("0" + dateObject.getDate()).slice(-2);

    const formattedDateString = `${year}-${month}-${day}`;
    this.setState(() => ({ dob: formattedDateString, isModified: true }));
  };

  handleSubmit = async (event) => {
    event.preventDefault();
    if (!this.validator.allValid()) {
      this.validator.showMessages();
      this.forceUpdate();
    } else {
      this.setState({ isLoading: true });
      try {
        const {
          first_name,
          last_name,
          email,
          phone_number,
          dob,
          gender_id,
          status_id,
          address_1,
          nic,
          type_id,
          mode_id,
          edu_id,
          higher_professional_qualifications,
          industry_experience,
          teaching_experience,
          checked_enrollments
        } = this.state;

        const teacherItem = {
          first_name: first_name,
          last_name: last_name,
          email: email,
          mobile: parseInt(phone_number),
          dob: !!dob ? dob : null,
          gender_id: parseInt(gender_id),
          status: parseInt(status_id),
          address_1: address_1,
          node_mid:
            !!this.props.state && !!this.props.state.mid
              ? this.props.state.mid
              : 100, //
          nic: nic,
          employee_type: parseInt(type_id),
          mode_of_employment: parseInt(mode_id),
          higher_educational_qualifications: parseInt(edu_id),
          industry_experience: industry_experience,
          teaching_experience: teaching_experience,
          higher_professional_qualifications:
            higher_professional_qualifications,
          new_enrollments:checked_enrollments,
        };
        const teacherResponse = await TeacherService.create_reg_teacher(
          JSON.stringify(teacherItem)
        );
        if (teacherResponse.success) {
          let userData = {
            user_code: teacherResponse.data.user_code,
            user_id: teacherResponse.data.user_id,
            user_table_id: teacherResponse.data.user_table_id,
          };
          await this.onFileUpload(userData);

          if (this.props.fetchAllTeachers) {
            this.props.fetchAllTeachers();
          }

          this.validator.purgeFields();
          this.validator.hideMessages();
          this.setState(this.formInitialState);

          try {
            this.setState({ isLoading: false, showInsertModal: false });

            sweetStatusAlert(
              "Success!",
              "Teacher added successfully..!",
              "success"
            );
            this.props.toggleAddTeacherModal();
            this.validator.purgeFields();
            this.validator.hideMessages();
            this.setState(this.formInitialState);
          } catch (error) {
            this.setState({ isLoading: false });
            sweetStatusAlert(
              "Failed!",
              "Failed to create new teacher",
              "error"
            );
          }
        } else {
          this.setState({ isLoading: false });
          sweetStatusAlert("Failed!", teacherResponse.message, "error");
        }
      } catch (e) {
        this.setState({ isLoading: false });
        sweetStatusAlert("Failed!", "Failed to create new teacher", "error");
      }
    }
  };

  getRespectiveStatusTypeID(name) {
    const type = this.state.statusTypes.find((item) => item.name === name);
    return type ? type.type_id : "";
  }

  getRespectiveRoleCode(role_code) {
    const roleData = this.state.roles.find(
      (role) => role.role_code === role_code
    );
    return roleData;
  }

  handleCreateRole = async () => {
    if (this.state.assignedRoles.length > 0) {
      const teacherUserRoleData = {
        user_id: this.state.assignedRoles[0].user_id,
        module:
          "Manage " +
          this.getRespectiveRoleCode(this.state.role_code).role_code,
        role_code: this.getRespectiveRoleCode(this.state.role_code).role_code,
      };
      try {
        await UserManagementService.createStaffRole(
          JSON.stringify(teacherUserRoleData)
        );
        await StaffService.searchStaffByTableAndUserIds(
          this.state.privedTeacher.user_id,
          this.state.main_table_id
        ).then((res) => {
          this.setState(() => ({
            assignedRoles: res.data,
          }));
        });
      } catch (error) {
        sweetStatusAlert("Failed", error, "error");
      }
    } else {
      sweetStatusAlert("Failed", "Cant able to Add Role", "error");
    }
  };

  handleDeleteRoleCode = async (teacherRole) => {
    try {
      await UserManagementService.deleteRoleCode(
        teacherRole.role_code,
        teacherRole.user_id
      );
      await StaffService.searchStaffByTableAndUserIds(
        this.state.privedTeacher.user_id,
        this.state.main_table_id
      ).then((res) => {
        this.setState(() => ({
          assignedRoles: res.data,
        }));
      });
    } catch (error) {}
  };

  getRespectiveRoleCode(role_code) {
    const roleData = this.state.roles.find(
      (role) => role.role_code === role_code
    );
    return roleData;
  }

  handleCreateRole = async () => {
    if (this.state.assignedRoles.length > 0) {
      const teacherUserRoleData = {
        user_id: this.state.assignedRoles[0].user_id,
        module:
          "Manage " +
          this.getRespectiveRoleCode(this.state.role_code).role_code,
        role_code: this.getRespectiveRoleCode(this.state.role_code).role_code,
      };
      try {
        await UserManagementService.createStaffRole(
          JSON.stringify(teacherUserRoleData)
        );
        await StaffService.searchStaffByTableAndUserIds(
          this.state.privedTeacher.user_id,
          this.state.main_table_id
        ).then((res) => {
          this.setState(() => ({
            assignedRoles: res.data,
          }));
        });
      } catch (error) {
        sweetStatusAlert("Failed", error, "error");
      }
    } else {
      sweetStatusAlert("Failed", "Cant able to Add Role", "error");
    }
  };

  handleDeleteRoleCode = async (teacherRole) => {
    try {
      await UserManagementService.deleteRoleCode(
        teacherRole.role_code,
        teacherRole.user_id
      );
      await StaffService.searchStaffByTableAndUserIds(
        this.state.privedTeacher.user_id,
        this.state.main_table_id
      ).then((res) => {
        this.setState(() => ({
          assignedRoles: res.data,
        }));
      });
    } catch (error) {}
  };

  toggleAddTeacherModal = () => {
    this.setState(
      (prevState) => ({
        showInsertModal: !prevState.showInsertModal,
        first_name: "",
        last_name: "",
        dob: "",
        email: "",
        phone_number: "",
        gender_id: "",
        status_id: "",
        created_on: "",
        created_by: "",
        address_1: "",
        type_id: "",
        mode_id: "",
        edu_id: "",
        higher_professional_qualifications: "",
        industry_experience: "",
        teaching_experience: "",
      }),
      () => {}
    );
  };

  handleUploadFiles = (uploadFiles) => {
    this.setState(
      {
        uploadFiles: uploadFiles,
      },
      () => {}
    );
  };

  // Helper function to read file as text
  readFile = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();

      reader.onload = (event) => {
        resolve(event.target.result);
      };

      reader.onerror = (error) => {
        reject(error);
      };

      reader.readAsArrayBuffer(file);
    });
  };

  handleBlobsDetail = async (
    labelName,
    selectedFileType,
    user_code,
    user_id
  ) => {
    const { uploadFiles } = this.state;

    const form_list = this.props.state.form_list_id;
    let blobIds = [];
    if (!!uploadFiles[selectedFileType].length) {
      const typeBlobDetails = await Promise.all(
        uploadFiles[selectedFileType]?.map(async (file, index) => {
          const name_ = file[0]?.name;
          const blobId = cgcDocSubmisBlobName(
            name_,
            form_list,
            labelName,
            index,
            user_code,
            user_id
          );
          const readData = await this.readFile(file[0]);
          blobIds.push(blobId);
          return {
            blobData: readData,
            blobName: blobId,
          };
        })
      );
      return {
        typeBlobDetails: typeBlobDetails,
        typeIds: blobIds,
      };
    } else {
      return {
        typeBlobDetails: [],
        typeIds: blobIds,
      };
    }
  };

  onFileUpload = async ({ user_code, user_id, user_table_id }) => {
    const { lg_user_id, lg_user_table_id } = this.state;
    const form_list = this.props.state.form_list_id;
    let container_id = `${customer}_form${form_list}`
      .toLowerCase()
      .replace(/[^a-z0-9-]/g, "-")
      .replace(/^-+|-+$/g, "");
    const handleBlobsDetailPhoto = await this.handleBlobsDetail(
      "photo",
      "selectedFilePhoto",
      user_code,
      user_id
    );
    const handleBlobsDetailNic = await this.handleBlobsDetail(
      "nic",
      "selectedFileNIC",
      user_code,
      user_id
    );
    const handleBlobsDetailCv = await this.handleBlobsDetail(
      "cv",
      "selectedFileCv",
      user_code,
      user_id
    );

    const handleBlobsDetailOther = await this.handleBlobsDetail(
      "other",
      "selectedFileOther",
      user_code,
      user_id
    );
    const blobDetailsAllType = await Promise.all([
      ...handleBlobsDetailPhoto.typeBlobDetails,
      ...handleBlobsDetailNic.typeBlobDetails,
      ...handleBlobsDetailCv.typeBlobDetails,
      ...handleBlobsDetailOther.typeBlobDetails,
    ]);
    try {
      await AzureStorageManage.multiUploadBlob(
        container_id,
        blobDetailsAllType
      );

      const obj = {
        user_id: user_id,
        user_table_id: user_table_id,
        create_user_id: lg_user_id,
        create_user_table_id: lg_user_table_id,
        container_id: container_id,
        blob_details: [
          {
            upload_type_id:
              regBTeacherUploadTypes.REG_B_TEACHER_PHOTO_UPLOADS.id,
            blob_ids: handleBlobsDetailPhoto?.typeIds,
          },
          {
            upload_type_id: regBTeacherUploadTypes.REG_B_TEACHER_NIC_UPLOADS.id,
            blob_ids: handleBlobsDetailNic?.typeIds,
          },
          {
            upload_type_id: regBTeacherUploadTypes.REG_B_TEACHER_CV_UPLOADS.id,
            blob_ids: handleBlobsDetailCv?.typeIds,
          },
          {
            upload_type_id:
              regBTeacherUploadTypes.REG_B_TEACHER_OTHER_UPLOADS.id,
            blob_ids: handleBlobsDetailOther?.typeIds,
          },
        ],
      };
      console.log("obj--->", obj);
      await TeacherService.addRegUploads(JSON.stringify(obj));
      // sweetStatusAlert(namespace.SUCCESS, `File uploaded successfully!!!`, "success")
    } catch (e) {
    } finally {
    }
  };

  handleCheckboxChange = (mid) => {
    this.setState((prevState) => {
      const updatedEnrollments = prevState.enrollments.map((course) =>
        course.mid === mid ? { ...course, checked: !course.checked } : course
      );
      const updatedCheckedEnrollments = updatedEnrollments.filter(
        (course) => course.checked
      );

      return {
        enrollments: updatedEnrollments,
        checked_enrollments: updatedCheckedEnrollments,
      };
    });
  };

  componentDidUpdate(prevProps) {
    if (prevProps.enrollments !== this.props.enrollments) {
      this.setState({ enrollments: this.props.enrollments });
    }
  }

  render() {
    const {
      isLoading,
      limit,
      teachers,
      totalTeachers,
      isTableDataLoading,
      currentPage,
      first_name,
      last_name,
      nic,
      email,
      phone_number,
      dob,
      gender_id,
      created_on,
      created_by,
      status_id,
      genders,
      adm_statuses,
      editVisibility,
      deleteVisibility,
      type_id,
      city_id,
      address_1,
      user_name,
      breadcrumb2,
      nodeTitle,
      addVisibility,
      roles,
      role_code,
      assignedRoles,
      isPrivModalLoading,
      empTypes,
      education,
      edu_id,
      modes,
      mode_id,
      higher_professional_qualifications,
      teaching_experience,
      industry_experience,
    } = this.state;
    const { isAddTeacherModalOpen, toggleAddTeacherModal } = this.props;
    this.validator.purgeFields();
    return (
      <>
        <>
          <Modal
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            show={isAddTeacherModalOpen}
            onHide={() =>
              this.handleSweetAlert(toggleAddTeacherModal, "showInsertModal")
            }
          >
            <Modal.Header closeButton>
              <Modal.Title>Create New Teacher</Modal.Title>
            </Modal.Header>
            <div>
              <Modal.Body>
                {isLoading ? (
                  <div
                    className="stu-card-title pt-2 col-md-12"
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <i className="fas fa-spinner fa-spin"></i>
                  </div>
                ) : (
                  <Form>
                    <Row>
                      <Modal.Title className="pl-4 mb-4">
                        Personal Details
                      </Modal.Title>
                    </Row>
                    <Row className="my-5">
                      <Form.Group
                        as={Col}
                        md="6"
                        controlId="exampleForm.ControlInput1"
                      >
                        <Form.Label>First Name*</Form.Label>
                        <Form.Control
                          type="text"
                          name="first_name"
                          value={first_name}
                          placeholder="First Name"
                          onChange={this.handleChange}
                        />
                        {this.validator.message(
                          "first_name",
                          first_name,
                          "required|alpha_space|min:2|max:15",
                          {
                            className: "text-danger",
                            messages: {
                              required: "The teacher first name is required.",
                            },
                          }
                        )}
                      </Form.Group>
                      <Form.Group
                        as={Col}
                        md="6"
                        controlId="exampleForm.ControlInput2"
                      >
                        <Form.Label>Last Name*</Form.Label>
                        <Form.Control
                          type="text"
                          name="last_name"
                          value={last_name}
                          placeholder="Last Name"
                          onChange={this.handleChange}
                        />
                        {this.validator.message(
                          "last_name",
                          last_name,
                          "required|alpha_space|min:2|max:15",
                          {
                            className: "text-danger",
                            messages: {
                              required: "The teacher last name is required.",
                            },
                          }
                        )}
                      </Form.Group>
                    </Row>
                    <Row className="my-5">
                      <Form.Group
                        as={Col}
                        md="6"
                        controlId="exampleForm.ControlInput2"
                      >
                        <Form.Label>NIC*</Form.Label>
                        <Form.Control
                          type="text"
                          name="nic"
                          placeholder="NIC"
                          onChange={this.handleChange}
                        />
                        {this.validator.message("nic", nic, "required|min:8", {
                          className: "text-danger",
                          messages: {
                            required: "The teacher nic is required.",
                          },
                        })}
                      </Form.Group>
                      <Form.Group
                        as={Col}
                        md="6"
                        controlId="exampleForm.ControlInput2"
                      >
                        <Form.Label>DOB*</Form.Label>
                        <div className="col-md-12 px-0">
                          <DatePicker
                            className="py-2 form-control w-100 col-md-12" // Add Bootstrap form control class
                            selected={
                              this.state.dob
                                ? new Date(this.state.dob)
                                : undefined
                            }
                            name="dob"
                            onChange={this.handleDatePickerChange}
                            dateFormat="dd/MM/yyyy" // Set custom date format
                            placeholderText="Date of Birth"
                            wrapperClassName="react-datePicker"
                          />
                        </div>
                        {this.validator.message(
                          "dob",
                          dob,
                          "required|dateBefore",
                          {
                            className: "text-danger",
                            messages: {
                              required: "The date of birth is required.",
                            },
                          }
                        )}
                      </Form.Group>
                    </Row>
                    <Row className="my-5">
                      <Form.Group
                        as={Col}
                        md="6"
                        controlId="exampleForm.ControlInput3"
                      >
                        <Form.Label>Email*</Form.Label>
                        <Form.Control
                          type="email"
                          name="email"
                          value={email}
                          placeholder="example@gmail.com"
                          onChange={this.handleChange}
                        />
                        {this.validator.message(
                          "email",
                          email,
                          "required|email",
                          {
                            className: "text-danger",
                            messages: {
                              required: "The email is required.",
                            },
                          }
                        )}
                      </Form.Group>
                      <Form.Group
                        as={Col}
                        md="6"
                        controlId="exampleForm.ControlInput3"
                      >
                        <Form.Label>Gender*</Form.Label>
                        <Form.Select
                          aria-label="Default select example"
                          name="gender_id"
                          value={gender_id}
                          onChange={this.handleChange}
                          defaultValue={""}
                        >
                          <option hidden value="">
                            Select
                          </option>
                          {genders?.map((gender) => (
                            <option
                              key={gender.gender_id}
                              value={gender.gender_id}
                            >
                              {gender.name}
                            </option>
                          ))}
                        </Form.Select>
                        {this.validator.message(
                          "gender_id",
                          gender_id,
                          "required",
                          {
                            className: "text-danger",
                            messages: {
                              required: "The gender is required.",
                            },
                          }
                        )}
                      </Form.Group>
                    </Row>

                    <Row className="my-5">
                      <Form.Group
                        as={Col}
                        md="6"
                        controlId="exampleForm.ControlInput3"
                      >
                        <Form.Label>Phone Number*</Form.Label>
                        <Form.Control
                          type="text"
                          name="phone_number"
                          value={phone_number}
                          placeholder="Phone Number"
                          onChange={this.handleChange}
                        />
                        {this.validator.message(
                          "phone_number",
                          phone_number,
                          "required|numeric|between:9,10|phone_number",
                          {
                            className: "text-danger",
                            messages: {
                              required: "The phone number is required.",
                            },
                          }
                        )}
                      </Form.Group>
                      <Form.Group
                        as={Col}
                        md="6"
                        controlId="exampleForm.ControlInput2"
                      >
                        <Form.Label>Permanent Address*</Form.Label>
                        <Form.Control
                          type="text"
                          name="address_1"
                          placeholder="Permanent Address"
                          onChange={this.handleChange}
                          value={address_1}
                        />
                        {this.validator.message(
                          "address_1",
                          address_1,
                          "required",
                          {
                            className: "text-danger",
                            messages: {
                              required: "The permanent address is required.",
                            },
                          }
                        )}
                      </Form.Group>
                    </Row>

                    <Row className="my-5">
                      <Form.Group
                        as={Col}
                        md="6"
                        controlId="exampleForm.ControlInput1"
                      >
                        <Form.Label>Status*</Form.Label>
                        <Form.Select
                          aria-label="Default select example"
                          name="status_id"
                          value={status_id}
                          onChange={this.handleChange}
                          defaultValue={""}
                        >
                          <option hidden value="">
                            Select
                          </option>
                          {adm_statuses?.map((status) => (
                            <option
                              key={status.status_id}
                              value={status.status_id}
                            >
                              {status.name}
                            </option>
                          ))}
                        </Form.Select>
                        {this.validator.message(
                          "status_id",
                          status_id,
                          "required",
                          {
                            className: "text-danger",
                            messages: {
                              required: "The status is required.",
                            },
                          }
                        )}
                      </Form.Group>
                    </Row>

                    <Row className="my-5">
                      <Form.Group
                        as={Col}
                        md="6"
                        controlId="exampleForm.ControlInput2"
                      >
                        {/* {this.validator.message(
                            "address_1",
                            address_1,
                            "address|required",
                            {
                            className: "text-danger",
                            messages: {
                                required: "The Address 1 is required.",
                                address: "The address 1 must be a valid address",
                            },
                            }
                        )} */}
                      </Form.Group>
                    </Row>
                    <Row className="my-5">
                      <Form.Group
                        as={Col}
                        md="6"
                        controlId="exampleForm.ControlInput2"
                      >
                        <Form.Label>Employment Type</Form.Label>
                        <Form.Select
                          aria-label="Default select example"
                          name="type_id"
                          onChange={this.handleChange}
                          value={type_id}
                        >
                          <option value="">Select</option>
                          {empTypes?.map((emp) => (
                            <option value={emp.type_id} key={emp.type_id}>
                              {emp.employment_type}
                            </option>
                          ))}
                        </Form.Select>
                        {/* {this.validator.message(
                            "country_id",
                            country_id,
                            "required",
                            {
                            className: "text-danger",
                            messages: {
                                required: "The Country is required.",
                            },
                            }
                        )} */}
                      </Form.Group>
                      <Form.Group
                        as={Col}
                        md="6"
                        controlId="exampleForm.ControlInput3"
                      >
                        <Form.Label>Mode Of Employment</Form.Label>
                        <Form.Select
                          aria-label="Default select example"
                          name="mode_id"
                          onChange={this.handleChange}
                          value={mode_id}
                        >
                          <option value="">Select</option>
                          {modes?.map((mode) => (
                            <option value={mode.mode_id} key={mode.mode_id}>
                              {mode.mode_of_employment}
                            </option>
                          ))}
                        </Form.Select>
                      </Form.Group>
                    </Row>
                    <Row className="my-5">
                      <Form.Group
                        as={Col}
                        md="6"
                        controlId="exampleForm.ControlInput3"
                      >
                        <Form.Label>
                          Higher Educational Qualifications
                        </Form.Label>
                        <Form.Select
                          aria-label="Default select example"
                          name="edu_id"
                          onChange={this.handleChange}
                          value={edu_id}
                        >
                          <option value="">Select</option>
                          {education?.map((edu) => (
                            <option value={edu.id} key={edu.id}>
                              {edu.title}
                            </option>
                          ))}
                        </Form.Select>
                      </Form.Group>

                      <Form.Group
                        as={Col}
                        md="6"
                        controlId="exampleForm.ControlInput2"
                      >
                        <Form.Label>
                          Higher Professional Qualifications
                        </Form.Label>
                        <Form.Control
                          type="text"
                          name="higher_professional_qualifications"
                          placeholder="Higher Professional Qualifications"
                          onChange={this.handleChange}
                          value={higher_professional_qualifications}
                        />
                      </Form.Group>
                    </Row>
                    <Row className="my-5">
                      <Form.Group
                        as={Col}
                        md="6"
                        controlId="exampleForm.ControlInput2"
                      ></Form.Group>
                    </Row>
                    <Row className="my-5">
                      <Form.Group
                        as={Col}
                        md="6"
                        controlId="exampleForm.ControlInput1"
                      >
                        <Form.Label>Industry Experience (Years)</Form.Label>
                        <Form.Control
                          type="number"
                          name="industry_experience"
                          placeholder="Industry Experience in years"
                          onChange={this.handleChange}
                          value={industry_experience}
                        />
                      </Form.Group>

                      <Form.Group
                        as={Col}
                        md="6"
                        controlId="exampleForm.ControlInput2"
                      >
                        <Form.Label>Teaching Experience (Years)</Form.Label>
                        <Form.Control
                          type="number"
                          name="teaching_experience"
                          placeholder="Teaching Experience in years"
                          onChange={this.handleChange}
                          value={teaching_experience}
                        />
                      </Form.Group>
                    </Row>

                    <Row className="pt-5">
                      <Modal.Title className="pl-4 mb-4">
                        Document Uploading
                      </Modal.Title>
                    </Row>
                    <Row className="my-5">
                      <RegBTeacherDocSubmission
                        uploadFiles={this.state.uploadFiles}
                        handleUploadFiles={this.handleUploadFiles}
                      />
                    </Row>

                    <Row className="pt-5">
                      <Modal.Title className="pl-4 mb-4">
                        Courses Assigned
                      </Modal.Title>
                    </Row>

                    <div className="cnt">
                    <Row className="course-list-container cNTableRow">
                      <Col>
                        {this.props.teacherEnrollmentsLoading ? (
                           <div className="spinner-container">
                           <CircularProgress />
                         </div> 
                        ) : (
                          <TableContainer
                            component={Paper}
                            className="course-table-container"
                          >
                            <Table aria-label="course table">
                              <TableHead className="table-head">
                                <TableRow>
                                  <TableCell className="table-cell">
                                    Select
                                  </TableCell>
                                  <TableCell className="table-cell">
                                    Course Name
                                  </TableCell>
                                </TableRow>
                              </TableHead>
                              <TableBody>
                                {this.state.enrollments?.map((course) => (
                                  <TableRow
                                    key={course.mid}
                                    className="table-row"
                                  >
                                    <TableCell className="table-cell cNTblCells">
                                      <Checkbox
                                        checked={course.checked || false}
                                        onChange={() =>
                                          this.handleCheckboxChange(course.mid)
                                        }
                                        className="course-checkbox"
                                      />
                                    </TableCell>
                                    <TableCell className="table-cell cNTblCells">
                                      {course.breadcrumb}
                                    </TableCell>
                                  </TableRow>
                                ))}
                              </TableBody>
                            </Table>
                          </TableContainer>
                        )}
                      </Col>
                    </Row>
                    </div>
                    {/* <Row className="my-5"></Row> */}

                    <Modal.Footer>
                      <Button
                        className="mb-4"
                        variant="primary"
                        style={addBtnStyle}
                        onClick={this.handleSubmit}
                      >
                        Save changes
                      </Button>
                      <Button
                        className="mb-4"
                        id="modal-close-button"
                        style={closeBtnStyle}
                        onClick={() =>
                          this.handleSweetAlert(
                            toggleAddTeacherModal,
                            "showInsertModal"
                          )
                        }
                      >
                        Close
                      </Button>
                    </Modal.Footer>
                  </Form>
                )}
              </Modal.Body>
            </div>
          </Modal>
        </>
      </>
    );
  }
}
